const intialState = {
    header:{},
    formations:[],
    impact_perspectives:[],
    activites_principales:[],
    competences:[],
    points_amelioration:[],
    projets_pro:[],
};

export default function reducer(state=intialState, action){

    switch (action.type){

        case "GET_ENTRETIEN_HEADER_FULFILLED":{
            return {
                ...state, header: action.payload.data.payload
            }
        }
        case "GET_FORMATIONS_FULFILLED":{
            return {
                ...state, formations: action.payload.data.payload
            }
        }
        case "GET_IMPACT_PERSPECTIVES_FULFILLED":{
            return {
                ...state, impact_perspectives: action.payload.data.payload
            }
        }
        case "GET_ACTIVITES_PRINCIPALES_FULFILLED":{
            return {
                ...state, activites_principales: action.payload.data.payload
            }
        }
        case "GET_COMPETENCES_FULFILLED":{
            return {
                ...state, competences: action.payload.data.payload
            }
        }
        case "GET_POINTS_AMELIORATION_FULFILLED":{
            return {
                ...state, points_amelioration: action.payload.data.payload
            }
        }
        case "GET_PROJETS_PRO_FULFILLED":{
            return {
                ...state, projets_pro: action.payload.data.payload
            }
        }
        case "SET_ACTIVITES_PRINCIPALES":{
            return {
                ...state, activites_principales: action.payload
            }
        }
        case "SET_POINTS_AMELIORATION":{
            return {
                ...state, points_amelioration: action.payload
            }
        }
        case "SET_ENTRETIEN_HEADER":{
            return {
                ...state, header: action.payload
            }
        }
        case "SET_FORMATIONS":{
            return {
                ...state, formations: action.payload
            }
        }
        default: {
            return state;
        }
    }
};


// WEBPACK FOOTER //
// ./src/reducers/entretien/_index.js